var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dg-modal',{attrs:{"size":"sm","show":_vm.show,"options":_vm.modalOptions},on:{"submit":function($event){return _vm.$emit('submit')},"close":function($event){return _vm.$emit('close')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }